export default {
  displayName: 'Nazwa schematu załadunku',
  description: 'Opis schematu załadunku',
  partIds: 'Części',
  assetIds: 'Urządzenia',
};
